import { render } from "./SvgCicrle.vue?vue&type=template&id=16cff896&scoped=true"
const script = {}

import "./SvgCicrle.vue?vue&type=style&index=0&id=16cff896&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cff896"]])

export default __exports__